<template>
  <div class="modal fade" id="sendMsgRawModal" tabindex="-1" aria-labelledby="sendMsgRawModalTitle">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="sendMsgRawModalTitle">
            Send MT/Downlink Message (Raw/Binary)
          </h5>
          <button type="button" class="btn-close" aria-label="Close" @click="closeModal"></button>
        </div>
        <div class="modal-body">
          <form class="card-body">
            
            <div class="col d-flex align-items-center mb-3">
              <label for="inputImsi" class="form-label small fw-bold me-3">IMSI</label>
              <input 
                type="text" 
                class="form-control form-control-sm" 
                id="inputImsi"
                pattern="^\d{14,15}$" 
                :placeholder="defaultImsi"
                required
                v-model="state.messageMeta.imsi" 
              />
            </div>
            
            <div class="col d-flex align-items-center {{ state.messageMeta.transport === 'NIDD' ? 'mb-3' : '' }}">
              <label for="inputTransport" class="form-label small fw-bold me-5">Transport</label>
              <div v-for="(t, index) in transports" :key="t" class="form-check form-check-inline">
                <input 
                  class="form-check-input" 
                  type="radio" 
                  :id="'option-' + index" 
                  :value="t" 
                  v-model="state.messageMeta.transport" 
                />
                <label class="form-check-label small" :for="'option-' + index">{{ t }}</label>
              </div>
            </div>

            <div v-if="state.messageMeta.transport === 'UDP'" class="row g-3 mb-3">
              
              <div class="col-sm-8">
                <label class="form-label small fm-bold" for="inputIp">IP Address</label>
                <input 
                  type="text" 
                  class="form-control form-control-sm" 
                  id="inputIp" 
                  placeholder="(lookup last known)"
                  pattern="^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$"
                  v-tooltip
                  title="A valid IPv4 address (empty will attempt last-known)"
                  v-model="state.messageMeta.ipAddress"
                />
              </div>

              <div class="col-sm-4">
                <label class="form-label small fm-bold" for="inputPort">Port</label>                
                <input 
                  type="number" 
                  class="form-control form-control-sm" 
                  id="inputPort" 
                  min="0"
                  max="65535" 
                  placeholder="5683"
                  v-model.number="state.messageMeta.ipPort"
                  @input="enforcePortRange"
                />
              </div>

            </div>

            <div>
              <label for="inputData" class="form-label small fw-bold">
                Payload
              </label>
              <input 
                type="text" 
                class="form-control form-control-sm" 
                pattern="^[0-9a-fA-F]{2}+$" 
                placeholder="313233" 
                id="inputData" 
                required
                v-tooltip
                title="Hexadecimal string (bytes)" 
                v-model="state.messageMeta.payload" 
              />
            </div>

          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeModal">Close</button>
          <button type="button" class="btn btn-primary" @click="saveObj">Submit</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, onMounted } from 'vue';
import { Modal } from 'bootstrap';

const emit = defineEmits(['formDataSubmitted', 'formClosed']);

const props = defineProps({
  defaultImsi: { type: String, default: '000000000000000' },
  defaultTransport: { type: String, default: 'NIDD' },
});

const state = reactive({
  modalMounted: null,
  messageMeta: {
    imsi: null,
    payload: null,
    transport: null,
    ipAddress: null,
    ipPort: null,
  },
});

const transports = ['NIDD', 'UDP'];

onMounted(() => {
  state.modalMounted = new Modal(`#sendMsgRawModal`, {});
  state.messageMeta.transport = props.defaultTransport;
  openModal();
});

function openModal() {
  state.modalMounted.show();
}

function closeModal() {
  state.modalMounted.hide();
  emit('formClosed');
}

async function saveObj() {
  state.modalMounted.hide();
  emit('formDataSubmitted', state.messageMeta);
}

</script>